export const FullPageLoader = ({ label = 'Yükleniyor...' }: { label?: string }) => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="text-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4" />
      <p className="text-muted-foreground">{label}</p>
    </div>
  </div>
);
